import "./Information.css";
import RERA from "../../assets/img/RER_A.png";


const Information = () => {

    return (
        <div id="information">
            <div className="information__container">
                <div className="information__box">
                    <h1>INFORMATIONS :</h1>
                    <div className="information__line"><div><h3>Horaires:</h3></div><div className="information__time"><h4> du Lundi au Samedi 11h00-14h00 et 18h00-22h00</h4></div></div>
                    <div className="information__line"><div><h3>Numéros de téléphone:</h3></div><div className="information__time"><a href="tel:0617496881" rel="noreferrer" target="_blank"><h4>+33 6.17.49.68.81</h4></a></div></div>
                    <div className="information__line">
                        <div><h3>Adresse:</h3></div>
                        <div className="information__time"><a href="https://goo.gl/maps/6ayY7oX2rSNvwuQE7" rel="noreferrer" target="_blank"><h4>1 Rue Jacques Daguerre, 92500 Rueil-Malmaison - France</h4></a></div>
                    </div>
                    <div className="information__line">
                        <div><h3>Comment nous rejoindre ?</h3></div>
                    </div>
                    <div className="information__line information__line__column"><img className="information__logo" src={RERA} alt="RER_A" /> <h4>RER A - Rueil-Malmaison</h4></div>
                </div>
                <div className="information__box">
                    <iframe
                        title="Google_Maps"
                        src={"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2623.369762876911!2d2.1700966000000026!3d48.88928990000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e6634243fcdcf7%3A0x34ea937846f79b92!2sNet%20VIET!5e0!3m2!1sfr!2sfr!4v1661976957691!5m2!1sfr!2sfr"}
                        height="80%"
                        width="90%"
                        style={{ border: 0, boxShadow: "0em 0em 0.5em 0.1em grey", position: "relative", top: "10%", alignSelf: "center" }}
                        allowfullscreen=""
                        loading="lazy">
                    </iframe>
                </div>
            </div>
        </div>
    );
};

export default Information;

/* <div className="information__schedule"><div><h3>Lundi</h3></div><div><h4>11h00-14h00 et 18h00-22h00</h4></div></div>
                    <div className="information__schedule"><div><h3>Mardi</h3></div><div><h4>11h00-14h00 et 18h00-22h00</h4></div></div>
                    <div className="information__schedule"><div><h3>Mercredi</h3></div><div><h4>11h00-14h00 et 18h00-22h00</h4></div></div>
                    <div className="information__schedule"><div><h3>Jeudi</h3></div><div><h4>11h00-14h00 et 18h00-22h00</h4></div></div>
                    <div className="information__schedule"><div><h3>Vendredi</h3></div><div><h4>11h00-14h00 et 18h00-22h00</h4></div></div>
                    <div className="information__schedule"><div><h3>Samedi</h3></div><div><h4>11h00-14h00 et 18h00-22h00</h4></div></div> */